import React , {useEffect, useState } from "react";
import { GetProfileImages } from "../DocumentDetails/slice";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import ListSubheader from "@mui/material/ListSubheader";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import FavoriteBorder from "@mui/icons-material/FavoriteBorder";
import Favorite from "@mui/icons-material/Favorite";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { esES } from "@mui/x-date-pickers";
import { useDispatch, useSelector } from "react-redux";
import {
  DEFAULT_AVATAR_URL,
  EntityFavoriteStatus,
  RegistrationStatus,
} from "../../common/enum";
import {
  getEntitiesList,
  setEntitiesLimit,
  setEntitiesOffset,
} from "../AdminView/adminSlice";
import { debounce } from "lodash";
import { Avatar, Button, ListItem } from "@mui/material";
import Loader from "../../components/Loader";
import { LoadingButton } from "@mui/lab";
import {
  addEntityFavorite,
  getEntityFavorites,
} from "../CollectorInvitation/slice";
import { useSnackbar } from "notistack";
import SvgIconStyle from "../../components/SvgIconStyle";
import { avataStyles, svgIconStyle } from "../DonationView/Cart/styles";
const BlacklistEntity = ({ t }) => {
  const {
    adminDashboard: {
      entitiesList,
      entitiesCount,
      drawerState,
      rejectPayload,
      entitiesLimit,
      entitiesOffset,
      confirmationDialog,
      loading,
      headerTitle,
    },
    auth: {
      user: { userId, entityId },
      profile: { entity },
    },
    collectorInvite: { entitiesFavorites },
  } = useSelector((state) => state);
  const dispatch = useDispatch();
  const timer = React.useRef(null);

  const [searchEntities, setSearchEntities] = React.useState([]);

  const getFavoriteEntities = React.useCallback(() => {
    const payload = {
      entityId: userId,
      status: EntityFavoriteStatus.blacklisted,
      isBlacklist: false,
    };
    dispatch(getEntityFavorites(payload));
  }, [dispatch, userId]);

  React.useEffect(() => {
    if (entitiesList.length > 0) {
      setSearchEntities((prev) => {
        // Combina a lista existente com a nova lista
        const combinedList = [...prev, ...entitiesList];
  
        // Remove duplicados com base no `data?.entity?.id`
        const seenIds = new Set();
        return combinedList.filter((item) => {
          const id = item?.entity?.id;
          if (seenIds.has(id)) {
            return false; // Já existe, remove.
          }
          seenIds.add(id); // Adiciona ao conjunto.
          return true; // É único, mantém.
        });
      });
    }
  }, [entitiesList]);

  React.useEffect(() => {
    setSearchEntities([]);
    getFavoriteEntities();
  }, []);

  const debouncedApiCall = debounce(async (value) => {
    const limit = value.skip + value.take;
    const offset = value.skip;
    let data = {
      limit: limit,
      offset: offset,
      status: RegistrationStatus.active,
      isDonorExcluded: true,
      entityName: value.entityName,
    };
    dispatch(getEntitiesList(data));
    dispatch(setEntitiesLimit(limit));
    dispatch(setEntitiesOffset(offset));
  }, 1000);

  const handleSerachBox = (event) => {
    setSearchEntities([]);
    // setSearchText(event.target.value);
    if (event.target.value.length > 0) {
      clearTimeout(timer.current);
      timer.current = setTimeout(() => {
        let value = {
          skip: 0,
          take: 50,
          entityName: event.target.value,
        };
        debouncedApiCall(value);
      }, 1000);
    }
  };

  const onHandleViewMore = () => {
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      let value = {
        skip: entitiesOffset + entitiesLimit,
        take: 50 + entitiesLimit,
        entityName: searchText,
      };
      debouncedApiCall(value);
    }, 1000);
  };

  const handleBlacklisted = (e, name) => {
    const data = {
      id: entitiesFavorites.find(
        (f) => f.favorites.entityId === name?.entity.entityId
      )
        ? entitiesFavorites.find(
            (f) => f.favorites.entityId === name?.entity.entityId
          ).favorites.id
        : 0,
      entityId: name?.entity.entityId,
      status: e.target.checked
        ? EntityFavoriteStatus.blacklisted
        : " ",
      updatedBy: userId,
    };
    dispatch(addEntityFavorite(data))
      .unwrap()
      .then((res) => {
        getFavoriteEntities();
      })
      .catch((err) => {
        console.error(err);
      });
  };

const [profileImages, setProfileImages] = useState(new Map());

useEffect(() => {
  const fetchImages = async () => {
    const newMap = new Map();

    for (const item of searchEntities) {
      const id = item?.entity?.profilePicture;
      if (id && id !== "string") {
        const result = await dispatch(GetProfileImages(id));
        const imageUrl = result?.payload?.isActive;
        if (imageUrl != null) {
          newMap.set(item.entity.entityId, imageUrl);
        }else{
            newMap.set(item.entity.entityId, AVATAR_URL);
        }
      }
    }

    setProfileImages(newMap);
  };

  fetchImages();
}, [searchEntities, dispatch]);

  return (
    <>
      <Typography sx={{paddingTop:"16px"}} variant="h6" textAlign={"center"}>
        {t("excludedEntites")}
      </Typography>
      <ListSubheader>
        <TextField
          size="small"
          sx={{
            mt: 1,
          }}
          // Autofocus on textfield
          autoFocus
          placeholder={t("typeToSearch")}
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            sx: { borderRadius: 5 },
          }}
          onChange={handleSerachBox}
          onKeyDown={(e) => {
            if (e.key !== "Escape") {
              // Prevents autoselecting item while typing (default Select behaviour)
              e.stopPropagation();
            } else if (e.key === "Enter") {
              handleSerachBox(e);
            }
          }}
        />
      </ListSubheader>
      <Paper
        variant="outlined"
        sx={{ maxHeight: "300px", overflow: "auto", m: 2, px: 1 }}
      >
        {loading && <Loader t={t} />}
        {searchEntities.length > 0 &&
          searchEntities.map(
            (name) =>
              entity?.entityId !== name?.entity.entityId && (
                <MenuItem
                  key={name?.entity.entityId}
                  value={name?.entity.entityName}
                  //   style={getStyles(name?.entity.entityName, personName, theme)}
                  sx={{ borderBottom: 1, borderColor: "divider" }}
                >
                  <Avatar
                    src={
                      name?.entity?.profilePicture !== "string"
                        ? profileImages.get(name?.entity.entityId)
                        : DEFAULT_AVATAR_URL
                    }
                    variant="rounded"
                    sx={{ backgroundColor: "green", mr: 1 }}
                  />
                  <ListItemText primary={name?.entity.entityName} />

                  <Checkbox
                    checked={entitiesFavorites.find(
                      (f) =>
                        f.favorites.entityId === name?.entity.entityId &&
                        f.favorites.status === EntityFavoriteStatus.blacklisted
                    )}
                    icon={<RadioButtonUncheckedIcon />}
                    checkedIcon={<CheckCircleIcon />}
                    color="error"
                    onChange={(e) => handleBlacklisted(e, name)}
                  />
                </MenuItem>
              )
          )}
        {/* {searchEntities.length > 0 && searchEntities.length < entitiesCount && (
          <LoadingButton
            loading={loading}
            sx={{ textAlign: "center", width: 1, mt: 1,borderRadius:'4px' }}
            onClick={onHandleViewMore}
          >
            {t("viewMore")}
          </LoadingButton>
        )} */}
      </Paper>
      <Box sx={{ m: 2, p: 1 }}>
        {entitiesFavorites.length > 0 &&
          entitiesFavorites.map((name) => (
            <ListItem
              key={name?.entity.entityId}
              //   style={getStyles(name?.entity.entityName, personName, theme)}
              sx={{ borderBottom: 1, borderColor: "divider" }}
            >
              <Avatar
                src={
                  name?.entity?.profilePicture !== "string"
                    ? profileImages.get(name?.entity.entityId)
                    : DEFAULT_AVATAR_URL
                }
                variant="rounded"
                sx={{ backgroundColor: "green", mr: 1 }}
              />
              <ListItemText primary={name?.entity.entityName} />
              <Checkbox
                checked={entitiesFavorites.find(
                  (f) =>
                    f.favorites.entityId === name?.entity.entityId &&
                    f.favorites.status === EntityFavoriteStatus.blacklisted
                )}
                icon={<RadioButtonUncheckedIcon />}
                checkedIcon={<CheckCircleIcon />}
                color="error"
                onChange={(e) => handleBlacklisted(e, name)}
              />
            </ListItem>
          ))}
        {entitiesFavorites.length === 0 && (
          <Typography
            variant="body1"
            fontFamily={"Poppins"}
            textAlign={"center"}
            sx={{textAlign: '-webkit-center'}}
          >
             <Avatar sx={avataStyles}>
              <SvgIconStyle src="/static/dashboard/icon-blacklist.svg" sx={svgIconStyle} />
            </Avatar>
            {t("noExcludedEntites")}
          </Typography>
        )}
      </Box>
    </>
  );
};

export default BlacklistEntity;
